import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import MainCollaborate from "../../components/collaborate/main-collaborate";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";

function Collaborate() {
  const { id } = useParams();
  const [nonprofit, setNonprofit] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadNonprofit = useCallback(async () => {
    if (!id) {
      setError("Invalid nonprofit id.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `${BASE_URL}${API_ENDPOINTS.NONPROFIT_DIRECTORY}/${id}`
      );
      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = result?.message || "Unable to load nonprofit details.";
        throw new Error(message);
      }

      setNonprofit(result?.data ?? null);
    } catch (err) {
      const message = err?.message || "Unable to load nonprofit details.";
      setError(message);
      toast.error(message);
      setNonprofit(null);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadNonprofit();
  }, [loadNonprofit]);

  return (
    <div className="w-[90%] lg:w-[95%] mx-auto mt-8">
      <MainCollaborate
        nonprofit={nonprofit}
        isLoading={isLoading}
        error={error}
        onRetry={loadNonprofit}
      />
    </div>
  );
}

export default Collaborate;


